import React from 'react';
import PropTypes from 'prop-types';

import Button from 'spa/Components/Button';

import {cn} from 'spa/css';

import './progress-button.less';

const ProgressButton = ({
  done, loading, theme, ...rest
}) => (
  <div className={cn(
    'progress-button',
    loading && 'progress-button--loading',
  )}>
    <Button
      theme={theme}
      isLoading={loading}
      {...rest}
    />
  </div>
);
ProgressButton.propTypes = {
  done: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,
  theme: PropTypes.string.isRequired,
};

export default ProgressButton;



// WEBPACK FOOTER //
// ./spa/Components/ProgressButton.jsx